const enabledMarketsKey = 'nuskin.mysite.eqmarkets';
const isEquinoxEnabledKey = 'isEquinoxEnabled';
const exportName = 'equinoxLocalStorage';


/**
 * @typedef {object} Market
 * @property {string} name
 * @property {string} storeID
 * 
 * @typedef {Object.<string, Market>} MarketList
 */

/**
 * getEnabledMarkets returns the list of equinox enabled markets.
 * An empty array will be returned if the item does not exist.
 * 
 * @deprecated Use contentstack.getEquinoxMarkets
 * @returns {MarketList | null}
 */
function getEnabledMarkets() {
    const markets = localStorage.getItem(enabledMarketsKey);

    if (markets === null || markets === '') {
        return null;
    }

    return JSON.parse(markets);
}

/**
 * getMarket returns the market name and store ID
 * of the given country code.
 *
 * @deprecated Use contentstack.isMarketEnabled
 * @param {string} countryCode
 * @return {Market | null}
 */
function getMarket(countryCode) {
    if (typeof countryCode === 'string') {
        const markets = getEnabledMarkets();

        if (markets === null) {
            return null;
        }

        const code = countryCode.toLocaleLowerCase();
        
        if (isMarketEnabled(code)) {
            return markets[code];
        }

        return null;
    }

    const fn = `${exportName}.getMarket`;
    console.error(`${fn}: expected a string, got ${typeof countryCode}.`);
    return null;
}

/**
 * isEquinoxEnabled returns `true` if isEquinoxEnabled is set in localstorage
 * and the value is set to "true". Otherwise, return `false`.
 *
 * @return {boolean}
 */
function isEquinoxEnabled() {
    const isEnabled = localStorage.getItem(isEquinoxEnabledKey);

    if (isEnabled !== null && isEnabled.toLowerCase() === 'true') {
        return true;
    }

    return false;
}

/**
 * isMarketEnabled checks if the current market is equinox enabled.
 *
 * @deprecated Use contentstack.isMarketEnabled
 * @param {string} countryCode 
 * @returns {boolean}
 */
function isMarketEnabled(countryCode) {
    if (typeof countryCode === 'string') {
        const markets = getEnabledMarkets();

        if (markets === null) {
            return false;
        }

        return Object.keys(markets)
            .includes(countryCode.toLowerCase())
            && isEquinoxEnabled();
    }

    const fn = `${exportName}.isMarketEnabled`;
    console.error(`${fn}: expected a string, got ${typeof countryCode}.`);
    return false;
}

/**
 * setEnabledMarkets stores the list of enabled markets in localstorage
 *
 * @deprecated
 * @param {MarketList} markets
 * @returns {boolean}
 */
function setEnabledMarkets(markets) {
    try {
        localStorage.setItem(enabledMarketsKey, JSON.stringify(markets));
        return true;
    } catch (err) {
        const fn = `${exportName}.setEnabledMarkets`;
        console.error(`${fn}: Unexpected error`, err);
        return false;
    }
}

export default {
    getEnabledMarkets,
    getMarket,
    setEnabledMarkets,
    isEquinoxEnabled,
    isMarketEnabled
}